import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import { IErrorResponse } from "../../../../types";
import {
    deletedRestoreWorkload,
    deletedWorkload,
    setItemWorkload,
    setRestoreWorkload,
    setTeachingLoad,
    setWorkloadData,
    updateWorkload,
} from "../store/workloadSlice";
import {
    IGetElectiveWorkload,
    ITeachingLoadCreate,
    ITeachingLoadPayload,
    IWorkloadCreate,
    IWorkloadPayload,
} from "../types";

const GetWorkload = createAsyncThunk("get/workload", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("/employee-workloads");
        dispatch(setWorkloadData(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetWorkload = createAsyncThunk("create/workload", async (data: IWorkloadCreate, { rejectWithValue }) => {
    try {
        return await request.post("/employee-workloads", data);
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const EditWorkload = createAsyncThunk(
    "edit/workload",
    async (data: IWorkloadPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/employee-workloads/${data.id}`, data);
            dispatch(updateWorkload(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteWorkload = createAsyncThunk("delete/workload", async (id: number, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.delete(`/employee-workloads/${id}`);
        dispatch(deletedWorkload(id));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetDeletedWorkload = createAsyncThunk("get/delete/workload", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/employee-workloads/deleted-items`);
        dispatch(setRestoreWorkload(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});
const RestoreDeleteWorkload = createAsyncThunk(
    "restore/delete/Workload",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/employee-workloads/restore/${id}`);
            dispatch(deletedRestoreWorkload(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetItemWorkload = createAsyncThunk("get/item/Workload", async (id: number, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/employee-workloads/${id}`);
        dispatch(setItemWorkload(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetElectiveWorkload = createAsyncThunk(
    "get/elective/Workload",
    async (selectedIDs: IGetElectiveWorkload, { rejectWithValue }) => {
        try {
            const response = await request.get(`/elective-subject/workload`, {
                params: {
                    ...selectedIDs,
                },
            });

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const WorkloadEducator = createAsyncThunk("post/Workload/educator", async (data: any, { rejectWithValue }) => {
    try {
        const response = await request.post("educator-workloads", data);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const EditWorkloadEducator = createAsyncThunk("put/Workload/educator", async (data: any, { rejectWithValue }) => {
    try {
        const response = await request.put(`educator-workloads/${data.id}`, data);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetWorkloadEducator = createAsyncThunk("get/Workload/educator", async (_, { rejectWithValue }) => {
    try {
        const response = await request.get("educator-workloads");

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteItemWorkload = createAsyncThunk("delete/item/Workload", async (id: number, { rejectWithValue }) => {
    try {
        await request.delete(`/educator-workloads/${id}`);
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetWorkloadNorms = createAsyncThunk("get/workload/norms", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await request.get("employee-workload/norms");
        dispatch(setTeachingLoad(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetWorkloadNorms = createAsyncThunk(
    "set/Workload/norms",
    async (data: ITeachingLoadCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("employee-workload/norms", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteWorkloadNorms = createAsyncThunk("delete/workload/norms", async (id: number, { rejectWithValue }) => {
    try {
        const response = await request.delete(`/employee-workload/norms/${id}`);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const EditWorkloadNorms = createAsyncThunk(
    "edit/workload/norms",
    async (data: ITeachingLoadPayload, { rejectWithValue }) => {
        try {
            const response = await request.put(`/employee-workload/norms/${data.id}`, data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetWorkload,
    SetWorkload,
    EditWorkload,
    DeleteWorkload,
    GetDeletedWorkload,
    RestoreDeleteWorkload,
    GetItemWorkload,
    GetElectiveWorkload,
    WorkloadEducator,
    GetWorkloadEducator,
    DeleteItemWorkload,
    GetWorkloadNorms,
    SetWorkloadNorms,
    DeleteWorkloadNorms,
    EditWorkloadNorms,
    EditWorkloadEducator,
};
